import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card } from '../common/Card';
import { Heading, Text } from '../common/Typography';

/**
 * ProfileSectionCard - Clickable card for profile sections
 * Mobile-first, tappable card that navigates to a profile section
 */
const ProfileSectionCard = ({
  path,
  icon,
  title,
  description,
  summary,
  className = '',
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = location.pathname === path || location.pathname.startsWith(path + '/');

  const handleClick = () => {
    navigate(path);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={`
        cursor-pointer transition-all active:scale-[0.98]
        ${isActive ? 'ring-2 ring-blue-500' : ''}
        ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      <Card
        variant="default"
        size="medium"
        className={`
          h-full hover:shadow-md
          ${isActive ? 'border-blue-500 bg-blue-50' : 'border-slate-200 hover:border-blue-300'}
        `.trim().replace(/\s+/g, ' ')}
      >
        <div className="flex items-start gap-4">
          {/* Icon */}
          <div className="text-4xl flex-shrink-0">
            {icon}
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <Heading level={4} className="mb-1">
              {title}
            </Heading>
            {description && (
              <Text className="text-sm text-slate-600 mb-2">
                {description}
              </Text>
            )}
            {summary && (
              <Text className="text-xs text-slate-500 font-medium">
                {summary}
              </Text>
            )}
          </div>

          {/* Arrow indicator */}
          <div className="flex-shrink-0 text-slate-400">
            →
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ProfileSectionCard;

